import React from "react";
import { classes } from "@bloomberg/media-ui-core";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./about.module.css";
import { QuoteData } from "~types/types";
import { TranslatedMessage } from "~utils/i18n";

export type AboutPageProps = {
  quoteData: QuoteData;
};
export default function About(props: AboutPageProps) {
  const { quoteData } = props;

  const {
    longName,
    companyDescription,
    indexDescription,
    companyAddress,
    companyWebsite,
    fundType,
    fundObjective,
    fundAssetClassFocus,
    fundManager,
  } = quoteData;

  if (!quoteData) {
    return null;
  }

  return (
    <div className={styles.aboutContainer}>
      <div className={styles.titleAndDescription}>
        <label
          className={typographyStyles.coreHeadlineXs}
          data-testid="aboutLabel"
        >
          <TranslatedMessage
            id="aboutLongname"
            values={{ longName }}
            defaultMessage="About {longName}"
          />
        </label>
        <p
          className={classes([
            styles.companyDescription,
            typographyStyles.coreParagraphMd,
          ])}
        >
          {companyDescription || indexDescription}
        </p>
      </div>
      <div className={styles.addressWebsiteContainer}>
        {companyAddress && (
          <div className={styles.addressContainer}>
            <label
              className={classes([
                styles.addressWebsiteLabel,
                typographyStyles.coreShortTextMd,
              ])}
            >
              <TranslatedMessage id="address" defaultMessage="Address" />
            </label>
            <div>{companyAddress}</div>
          </div>
        )}
        {companyWebsite && (
          <div className={styles.websiteContainer}>
            <label
              className={classes([
                styles.addressWebsiteLabel,
                typographyStyles.coreShortTextMd,
              ])}
            >
              <TranslatedMessage id="website" defaultMessage="Website" />
            </label>
            <p>
              <a
                href={`https://${companyWebsite}`}
                className={styles.websiteLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {companyWebsite}
              </a>
            </p>
          </div>
        )}
      </div>
      <div className={styles.fundDetails}>
        {fundType && (
          <div>
            <label className={styles.addressWebsiteLabel}>
              <TranslatedMessage
                id="fundDetails"
                defaultMessage="Fund Details"
              />
            </label>
            <div className={styles.fundDetailColumn}>
              <span className={styles.fundTypeAndObjective}>
                <TranslatedMessage id="fundType" defaultMessage="Fund Type" />
              </span>
              <span className={styles.fundDetailValue}>{fundType}</span>
            </div>
          </div>
        )}
        {fundObjective && (
          <div className={styles.fundDetailColumn}>
            <span className={styles.fundTypeAndObjective}>
              <TranslatedMessage id="objective" defaultMessage="Objective" />
            </span>
            <span className={styles.fundDetailValue}>{fundObjective}</span>
          </div>
        )}
        {fundAssetClassFocus && (
          <div className={styles.fundDetailColumn}>
            <span className={styles.assetClassFocus}>
              <TranslatedMessage
                id="assetClassFocus"
                defaultMessage="Asset Class Focus"
              />
            </span>
            <span className={styles.fundDetailValue}>
              {fundAssetClassFocus}
            </span>
          </div>
        )}
        {fundManager && (
          <div className={styles.fundDetailColumn}>
            <span className={styles.fundManager}>
              <TranslatedMessage
                id="fundManagers"
                defaultMessage="Fund Manager(s)"
              />
            </span>
            <span className={styles.fundDetailValue}>{fundManager}</span>
          </div>
        )}
      </div>
    </div>
  );
}
